export const amchartCountryList = {
  "GB-ENG": "ENGLAND",
  "GB-NIR": "NORTHERN IRELAND",
  "GB-SCT": "SCOTLAND",
  "GB-WLS": "WALES",
};
